export default {
  ERROR: '/identity/signup/error',
  LINK: '/link',
  LINK_EXISTING_ACCOUNT: '/link/existing-account',
  LITE: '/lite',
  NO_IDP: '/no-idp',
  QR: '/qr',
  QR_VERIFY: '/qr/verify',
  RUSSIAN_TERMS: '/terms-ru',
  SESSION_EXPIRED: '/identity/signup/session-expired',
  USE_MY_PHONE: '/qr/use-my-phone',
  VERIFY_OTT: '/email',
  TERMS: '/terms',
}
